import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=20b43f09&scoped=true"
import script from "./loading.ts?vue&type=script&lang=ts&external"
export * from "./loading.ts?vue&type=script&lang=ts&external"
import style0 from "./loading.less?vue&type=style&index=0&id=20b43f09&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b43f09",
  null
  
)

export default component.exports